import {
  BellRegularIcon,
  CalendarPenRegularIcon,
  CalendarRegularIcon,
  ListTimelineRegularIcon,
  PillsRegularIcon,
  PrescriptionSolidIcon,
  StarOfLifeSolidIcon,
  UploadRegularIcon,
  BedFilledIcon,
  BanRegularIcon,
  PauseRegularIcon,
  PrintRegularIcon,
  LoaderV3Icon,
} from "@elixir/icons";
import { usePackageBookingStore } from "@elixir/stores";
import {
  Appointment,
  MODES_OF_APT,
  PACKAGE_POPUP_TYPE,
  SUBJECT_KEYS,
} from "@elixir/types";
import {
  copyToClipboard,
  getAclViewClassName,
  isBusinessWhitelisted,
} from "@elixir/utils";
import { Menu, Modal, notification } from "antd";
import React, { useEffect, useState } from "react";
import useSendVisitSms from "../../../apis/parchi/use-send-visit-sms";
import useCancelAppointmentMutation from "../../../apis/tryst/cancel-appointment";
import useArchiveAppointment from "../../../apis/tryst/delete-archive-appointment";
import usePostPassPromoMsg from "../../../apis/tryst/use-post-pass-promo-msg";
import { ReactComponent as ChevronDownRegularIcon } from "../../../assets/icons/chevron-down-regular.svg";
import { ReactComponent as ABHAIcon } from "../../../assets/icons/custom/abha.svg";
import { ReactComponent as ArrowUpRightRegularIcon } from "../../../assets/icons/font-awesome/arrow-up-right-regular.svg";
import { ReactComponent as CircleXmarkRegularIcon } from "../../../assets/icons/font-awesome/circle-xmark-regular.svg";
import { ReactComponent as EditRegularIcon } from "../../../assets/icons/font-awesome/edit-regular.svg";
import { ReactComponent as FileRegularIcon } from "../../../assets/icons/font-awesome/file-regular.svg";
import { ReactComponent as FilesRegularIcon } from "../../../assets/icons/font-awesome/files-regular.svg";
import { ReactComponent as FlaskRegularIcon } from "../../../assets/icons/font-awesome/flask-regular.svg";
import { ReactComponent as GSolidIcon } from "../../../assets/icons/font-awesome/g-solid.svg";
import { ReactComponent as PillsSolidIcon } from "../../../assets/icons/font-awesome/pills-solid.svg";
import { ReactComponent as SARegularIcon } from "../../../assets/icons/font-awesome/sa-regular.svg";
import { ReactComponent as ThermometerRegularIcon } from "../../../assets/icons/font-awesome/thermometer-regular.svg";
import { ReactComponent as TrashRegularIcon } from "../../../assets/icons/font-awesome/trash-regular.svg";
import { ReactComponent as UserCircleRegularIcon } from "../../../assets/icons/font-awesome/user-circle-regular.svg";
import { ReactComponent as ReceiptRegularIcon } from "../../../assets/icons/receipt-regular.svg";
import { ReactComponent as SyringeRegularIcon } from "../../../assets/icons/font-awesome/syringe-regular.svg";
import { QUEUE_TYPE } from "../../../constants/appointments";
import { METROLPOLIS_HOST } from "../../../constants/env";
import useBillingStore from "../../../stores/billing-store/billing-store";
import useQueueStore from "../../../stores/queue-store";
import { APPOINTMENT_STATUS } from "../../../stores/queue-store/enums";
import {
  getBusinessConfigs,
  getMe,
  initMedicalCertificate,
  isCanBookLabTest,
  isCanOrderMedicine,
  isPrintLabelEnabled,
  isDoctorOnly,
  isGoogleReviewLinkSetup,
  isIpdEnabled,
  isTreatmentPlanEnabled,
  navigate,
  onAddVaccination,
  onAddVitalsAction,
  onBookLabTestAction,
  onOpenAdmitPatientDrawer,
  onOpenTreatmentPlan,
  onOrderMedicineAction,
  onPatientEditAction,
  onReferAdocAction,
  onRequestMedicalRecordsAction,
  onShowSAAction,
  onUploadMedicalRecordEvent,
  printLabelForPatientWithId,
  openCreateAbhaFlow,
  showGoogleReviewDialog,
} from "../../../utils/bridges/methods";
import {
  createNewReceipt,
  sendPaymentLink,
  settleDues,
  viewAllReceipt,
} from "../../../utils/receipt";
import { track } from "../../../utils/tracking";
import useGetQueueConfig from "../../../apis/tryst/get-queue-config";
import { sendBusinessGoogleReviewLink } from "apis";
import usePostPushOrderToEvitals from "../../../apis/parchi/use-post-push-order-to-evitals";
import getB from "../../../utils/bridges/EkaBridge";
import useMarkNoShowMutation from "../../../apis/tryst/post-mark-no-show";
import useMarkParkedMutation from "../../../apis/tryst/post-park-apt";
import {
  usePrintOpdSlip,
} from "../../../molecules/button/queue/actions/print-opd-slip-button";
import { FirebaseAppointment } from "../../../firestore/types";

type TMenuItemProps = {
  text: string;
  rightIcon?: React.ReactNode;
  icon?: React.ReactNode;
  onClick?: () => void | Promise<void>;
  subMenu?: { text: string; onClick: () => void }[];
  aclViewClassName?: string;
};

const MenuItem = ({
  text,
  icon,
  onClick,
  subMenu,
  rightIcon,
  aclViewClassName,
  ...props
}: TMenuItemProps) => {
  if (subMenu) {
    return (
      <Menu.SubMenu
        {...props}
        title={
          <div className="dr-flex dr-justify-between dr-items-center dr-px-2">
            <div className="dr-flex-1 dr-flex dr-space-x-8 dr-items-center">
              {icon}
              <div className="dr-flex dr-items-center dr-justify-between dr-flex-1">
                <div className="dr-flex dr-items-center dr-justify-between BodyBody2Regular dr-py-8 dr-text-darwin-touch-neutral-1000">
                  {text}
                </div>
                <div className="-mr-16">{rightIcon}</div>
              </div>
            </div>
            {/* <ChevronDownRegular className="dr-rotate-270 dr-doctor-darwin-neutral-200 w-12 h-12" /> */}
          </div>
        }
        className={aclViewClassName || ""}
      >
        {subMenu.map((item, idx) => (
          <Menu.Item
            key={idx}
            onClick={item.onClick}
            className="dr-px-14"
            style={{ paddingLeft: ".875rem", paddingRight: ".875rem" }}
          >
            <div className="dr-flex dr-items-center dr-justify-between BodyBody2Regular dr-py-8  dr-text-darwin-touch-neutral-1000">
              {item.text}
            </div>
          </Menu.Item>
        ))}
      </Menu.SubMenu>
    );
  }
  return (
    <Menu.Item
      {...props}
      icon={icon}
      onClick={onClick}
      className={`dr-px-14 ${aclViewClassName || ""}`}
      style={{ paddingLeft: ".875rem", paddingRight: ".875rem" }}
    >
      <div className="dr-flex dr-items-center dr-justify-between BodyBody2Regular dr-py-8  dr-text-darwin-touch-neutral-1000">
        {text}
      </div>
    </Menu.Item>
  );
};

const useGetMenuItems = (
  apt: Appointment,
  queueType: QUEUE_TYPE
): Array<TMenuItemProps> => {
  const {
    aid,
    patient_oid,
    sa_id,
    receipts,
    patient,
    status,
    clinic_id,
    abha,
    prescription_id,
  } = apt || {};
  const isOnGoing = status === APPOINTMENT_STATUS.ONGOING;
  const isCancelled =
    status === APPOINTMENT_STATUS.CANCELLED ||
    status === APPOINTMENT_STATUS.STAFF_CANCELLED ||
    status === APPOINTMENT_STATUS.DOCTOR_CANCELLED;
  const isCompleted =
    status === APPOINTMENT_STATUS.COMPLETED ||
    status === APPOINTMENT_STATUS.COMPLETED_NO_PRESCRIPTION;
  const markNoShowConditions =
    status === APPOINTMENT_STATUS.BOOKED ||
    status === APPOINTMENT_STATUS.RESCHEDULED ||
    status === APPOINTMENT_STATUS.STAFF_RESCHEDULED ||
    status === APPOINTMENT_STATUS.CHECKED_IN;

  const parkVisitConditions =
    status === APPOINTMENT_STATUS.BOOKED ||
    status === APPOINTMENT_STATUS.RESCHEDULED ||
    status === APPOINTMENT_STATUS.STAFF_RESCHEDULED ||
    status === APPOINTMENT_STATUS.CHECKED_IN ||
    status === APPOINTMENT_STATUS.ONGOING;
  const clinicId = useQueueStore((state) => state.clinicId);
  const setClinicId = useBillingStore((state) => state.setClinicId);
  const setShowAppointmentDetailsDrawer = useQueueStore(
    (state) => state.setShowAppointmentDetailsDrawer
  );
  const setSelectedAppointment = useQueueStore(
    (state) => state.setSelectedAppointment
  );
  const [parkVisitEnabled, setParkVisitEnabled] = useState(false);
  const [printLabelEnabled, setPrintLabelEnabled] = useState(false);
  const setShowSendReminderModal = useQueueStore(
    (state) => state.setShowSendReminderModal
  );
  const setSelectSlotInfo = useQueueStore((state) => state.setSelectSlotInfo);
  const evitalsConfig = useQueueStore((state) => state.evitalsConfig);
  const setSelectedPackageAppointment = usePackageBookingStore(
    (state) => state.setSelectedAppointment
  );
  const setSelectedPackagePatient = usePackageBookingStore(
    (state) => state.setSelectedPatient
  );
  const setConductingDoctor = usePackageBookingStore(
    (state) => state.setConductingDoctor
  );
  const { mutateAsync: postMarkNoShowAppointment } = useMarkNoShowMutation();
  const { mutateAsync: postMarkParkedAppointment } = useMarkParkedMutation();
  const [isCanPlaceOrder, setIsCanPlaceOrder] = useState(false);
  useEffect(() => {
    const fetch = async () => {
      const placeOrderFlag = await isCanOrderMedicine();
      const enableParkVisitCta = await getBusinessConfigs();
      setParkVisitEnabled(enableParkVisitCta?.parkVisitEnabled ?? false);
      setIsCanPlaceOrder(placeOrderFlag);
      try {
        const enabled = await isPrintLabelEnabled();
        setPrintLabelEnabled(enabled);
      } catch {
        setPrintLabelEnabled(false);
      }
    };
    fetch();
  }, []);

  const { mutateAsync: putCancelAppointment } = useCancelAppointmentMutation();
  const { mutateAsync: postArchiveAppointment } = useArchiveAppointment();
  const { data: queueConfigData } = useGetQueueConfig();
  const { apt_config } = queueConfigData?.data || {};
  const { pre_consulation_notes } = apt_config || {};

  const [isCanBookLabTestFlag, setIsCanBookLabTestFlag] = React.useState(false);
  useEffect(() => {
    const fetchData = async () => {
      const res = await isCanBookLabTest();
      setIsCanBookLabTestFlag(res);
    };
    fetchData();
  }, []);

  useEffect(() => {
    setClinicId({ clinicId: clinicId });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [clinicId]);

  const [showAdmitPatient, setShowAdmitPatient] = useState(false);

  useEffect(() => {
    isIpdEnabled().then((isIpdEnabled) => {
      setShowAdmitPatient(isIpdEnabled);
    });
  }, []);

  const { mutateAsync: sendVisitSms } = useSendVisitSms();
  const { mutateAsync: postPassPromoMsg } = usePostPassPromoMsg();
  const { mutateAsync: postPushOrderToEvitals } = usePostPushOrderToEvitals();
  const { handlePrintOpdSlip, loading: printOpdSlipLoading } = usePrintOpdSlip(
    apt as unknown as FirebaseAppointment
  );

  const setPackagePopupType = usePackageBookingStore(
    (state) => state.setPackagePopupType
  );

  const isAbhaCreated = !!abha?.id;

  const handleReviewLinkSend = async () => {
    const isGoogleReviewLinkSetupFlag = isGoogleReviewLinkSetup(apt.doctor_oid);

    if (!isGoogleReviewLinkSetupFlag) {
      showGoogleReviewDialog({ docId: apt.doctor_oid });
      return;
    }

    const response = await sendBusinessGoogleReviewLink({
      aid,
    });

    if (response.success) {
      notification.success({
        message: "Google Review Link Sent",
        description: `Google review link has been sent to ${apt.patient.fln}.`,
        placement: "bottomRight",
      });
    } else {
      notification.error({
        message: "Error in sending google review link",
        description: response.error || "Something went wrong.",
        placement: "bottomRight",
      });
    }
  };

  const handlePushOrderToEvitals = async (aid: Appointment["aid"]) => {
    const { status } = await postPushOrderToEvitals({ aid });
    if (status === "success") {
      notification.success({
        message: "Order pushed to evitals successfully!",
        placement: "bottomRight",
      });
    } else {
      notification.error({
        message: "Error occured while pushing order to evitals!",
        placement: "bottomRight",
      });
    }
  };

  const handleSendMsgPress = async (aid: Appointment["aid"]) => {
    const { isSent } = await sendVisitSms({ aid });
    if (isSent) {
      notification.success({
        message: "Prescription for appointment sent successfully!",
        placement: "bottomRight",
      });
    } else {
      notification.error({
        message: "Error occured while sending prescription!",
        placement: "bottomRight",
      });
    }
  };

  const handlePassPromoMsgClick = async (aid: Appointment["aid"]) => {
    const { success, error } = await postPassPromoMsg({ aid });
    if (success) {
      notification.success({
        message: "Promotional Message sent successfully!",
        placement: "bottomRight",
      });
    } else {
      notification.error({
        message: error,
        placement: "bottomRight",
      });
    }
  };

  const handleStartTreatmentCLick = () => {
    if (isTreatmentPlanEnabled()) {
      onOpenTreatmentPlan(apt);
    } else {
      setSelectedPackageAppointment(apt);
      setSelectedPackagePatient(apt.patient);
      setConductingDoctor(
        getMe().doctors.find((item) => item.oid === apt.doctor_oid)!
      );
      if ([QUEUE_TYPE.CHECKED_IN, QUEUE_TYPE.BOOKED].includes(queueType)) {
        setPackagePopupType(PACKAGE_POPUP_TYPE.START_OR_CURRENT_TREATMENT);
      } else {
        setPackagePopupType(PACKAGE_POPUP_TYPE.START_TREATMENT);
      }
    }
  };

  const handleAdmitPatientCLick = () => {
    onOpenAdmitPatientDrawer(apt);
  };

  const isDoctorPersonaOnly = isDoctorOnly();

  return [
    {
      text: "Bill",
      icon: <ReceiptRegularIcon className="dr-w-16 dr-h-16" />,
      rightIcon: (
        <ChevronDownRegularIcon className="dr-w-16 dr-h-16 -dr-rotate-90" />
      ),
      subMenu: [
        {
          text: "Bill Patient",
          onClick: () => {
            createNewReceipt({ appointment: apt });
          },
        },
        ...(receipts.length
          ? [
            {
              text: "View Receipts",
              onClick: () => {
                viewAllReceipt({ appointment: apt });
              },
            },
          ]
          : []),
        ...(patient.amount_pending && patient.amount_pending > 0
          ? [
            {
              text: `Clear Dues (₹ ${patient.amount_pending})`,
              onClick: () => {
                settleDues({ appointment: apt });
              },
            },
          ]
          : []),
        {
          text: "Request Payment",
          onClick: () => {
            sendPaymentLink({ appointment: apt });
          },
        },
      ],
      aclViewClassName: getAclViewClassName(
        SUBJECT_KEYS.CAN_CREATE_RECEIPT_WITH_APT
      ),
    },
    ...(QUEUE_TYPE.COMPLETED && showAdmitPatient
      ? [
        {
          text: "Admit Patient",
          icon: <BedFilledIcon className="dr-w-16 dr-h-16" />,
          onClick: handleAdmitPatientCLick,
        },
      ]
      : []),
    ...([
      QUEUE_TYPE.COMPLETED,
      QUEUE_TYPE.CHECKED_IN,
      QUEUE_TYPE.BOOKED,
    ].includes(queueType)
      ? [
        {
          text: "Start Treatment",
          icon: <StarOfLifeSolidIcon className="dr-w-16 dr-h-16" />,
          onClick: handleStartTreatmentCLick,
          aclViewClassName: getAclViewClassName(SUBJECT_KEYS.TREATMENT),
        },
      ]
      : []),

    ...([QUEUE_TYPE.CHECKED_IN].includes(queueType)
      ? [
        { text: "" },
        {
          text: "Patient Details",
          icon: <UserCircleRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            track("more_dropdown_patient_details", {
              queueType,
            });
            if (patient_oid) {
              navigate("push", `/app/patient/${patient_oid}/visit`);
            } else {
              alert("Something went wrong");
            }
          },
        },
        {
          text: "Edit Patient",
          icon: <EditRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: async () => {
            onPatientEditAction(apt);
          },
          aclViewClassName: getAclViewClassName(
            SUBJECT_KEYS.PATIENT_DATABASE
          ),
        },
      ]
      : []),
    ...([
      QUEUE_TYPE.CHECKED_IN,
      QUEUE_TYPE.BOOKED,
      QUEUE_TYPE.FOLLOWUP,
    ].includes(queueType) && apt.mode === MODES_OF_APT.TELE
      ? [
        {
          text: "Copy Patient's Tele Link",
          icon: <FilesRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: async () => {
            const isMetroPolis = isBusinessWhitelisted({
              businessId: apt.business_id!,
            });
            let teleLink = "";
            if (isMetroPolis) {
              teleLink = `${METROLPOLIS_HOST}?apptid=${apt.aid}`;
            } else {
              const link = await getB().getAppointmentUrls(apt.aid);
              if (link?.guest_link) {
                teleLink = link?.guest_link;
              }
            }
            copyToClipboard({
              text: teleLink,
            });
            notification.success({
              message: "Tele Link Copied",
              placement: "bottomRight",
            });
          },
        },
      ]
      : []),

    ...([QUEUE_TYPE.COMPLETED].includes(queueType)
      ? [
        ...(isCanBookLabTestFlag || isCanPlaceOrder ? [{ text: "" }] : []),
        ...(isCanBookLabTestFlag
          ? [
            {
              text: "Book Lab test actions",
              icon: <FlaskRegularIcon className="dr-w-16 dr-h-16" />,
              onClick: () => {
                onBookLabTestAction(apt);
              },
            },
          ]
          : []),
        ...(isCanPlaceOrder
          ? [
            {
              text: "Order Medicine",
              icon: <PillsSolidIcon className="dr-w-16 dr-h-16" />,
              onClick: () => {
                onOrderMedicineAction(apt);
              },
            },
          ]
          : []),
      ]
      : []),

    { text: "" },
    ...([QUEUE_TYPE.COMPLETED].includes(queueType)
      ? []
      : [
        {
          text: "Add Vaccination",
          icon: <SyringeRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            onAddVaccination(apt);
          },
          aclViewClassName: getAclViewClassName(SUBJECT_KEYS.ADD_VACCINATION),
        },
        {
          text: "Add Vitals & Lab Results",
          icon: <ThermometerRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            onAddVitalsAction(apt);
          },
          aclViewClassName: getAclViewClassName(
            SUBJECT_KEYS.VITALS_COLLECTION
          ),
        },
        ...(isDoctorPersonaOnly
          ? [
            {
              text: "Request Records",
              icon: <FilesRegularIcon className="dr-w-16 dr-h-16" />,
              onClick: async () => {
                onRequestMedicalRecordsAction(apt);
              },
              aclViewClassName: getAclViewClassName(
                SUBJECT_KEYS.CAN_REQUEST_RECORDS
              ),
            },
          ]
          : []),
      ]),
    ...(pre_consulation_notes && [QUEUE_TYPE.BOOKED].includes(queueType)
      ? [
        {
          text: "Reschedule Appointment",
          icon: <CalendarPenRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            setSelectedAppointment(apt);
            setSelectSlotInfo({
              aptChannel: "BOOKED",
              bookType: "RESCHEDULE",
              showModal: true,
            });
          },
        },
        {
          text: "Send Reminder",
          icon: <BellRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            setSelectedAppointment(apt);
            setShowSendReminderModal(true);
          },
          aclViewClassName: getAclViewClassName(SUBJECT_KEYS.SEND_REMINDER),
        },
      ]
      : []),
    ...(pre_consulation_notes && [QUEUE_TYPE.FOLLOWUP].includes(queueType)
      ? [
        {
          text: "Book Appointment",
          icon: <CalendarRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            setSelectedAppointment(apt);
            setSelectSlotInfo({
              aptChannel: "FOLLOW-UP",
              bookType: "SCHEDULE",
              showModal: true,
            });
          },
        },
        {
          text: "Send Follow-up Reminder",
          icon: <BellRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            setSelectedAppointment(apt);
            setShowSendReminderModal(true);
          },
          aclViewClassName: getAclViewClassName(SUBJECT_KEYS.SEND_REMINDER),
        },
      ]
      : []),
    ...(sa_id
      ? [
        {
          text: "Self Assessment Details",
          icon: <SARegularIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            onShowSAAction({ a: apt });
          },
        },
      ]
      : []),
    {
      text: "Refer a Doctor",
      icon: <ArrowUpRightRegularIcon className="dr-w-16 dr-h-16" />,
      onClick: () => {
        onReferAdocAction(apt);
      },
      aclViewClassName: getAclViewClassName(
        SUBJECT_KEYS.REFER_PATIENT_TO_DOCTOR
      ),
    },
    ...(!isAbhaCreated
      ? [
        {
          text: "Create ABHA",
          icon: <ABHAIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            openCreateAbhaFlow(apt);
          },
          aclViewClassName: getAclViewClassName(SUBJECT_KEYS.ABHA),
        },
      ]
      : []),
    // ...([QUEUE_TYPE.BOOKED].includes(queueType)
    //   ? [
    //       {
    //         text: "Add Tags",
    //         icon: <TagRegularIcon className="dr-w-16 dr-h-16" />,
    //         subMenu: [
    //           {
    //             text: "Bill je",
    //             onClick: () => {
    //               setReceiptPopupData({ aid, receiptState: "create" });
    //             },
    //           },
    //         ],
    //       },
    //     ]
    //   : []),
    {
      text: "Create Medical Certificate",
      icon: <FileRegularIcon className="dr-w-16 dr-h-16" />,
      onClick: () => {
        initMedicalCertificate(apt);
      },
      aclViewClassName: getAclViewClassName(
        SUBJECT_KEYS.CREATE_MEDICAL_DOCUMENTS
      ),
    },
    {
      text: "Upload Medical Records",
      icon: <UploadRegularIcon className="dr-w-16 dr-h-16" />,
      rightIcon: (
        <ChevronDownRegularIcon className="dr-w-16 dr-h-16 -dr-rotate-90" />
      ),
      subMenu: [
        {
          text: "Upload file",
          onClick: () => {
            onUploadMedicalRecordEvent(apt.patient_oid, { source: "file" });
          },
        },
        {
          text: "Take picture",
          onClick: () => {
            onUploadMedicalRecordEvent(apt.patient_oid, { source: "camera" });
          },
        },
      ],
      aclViewClassName: getAclViewClassName(
        SUBJECT_KEYS.UPLOAD_MEDICAL_RECORDS
      ),
    },
    ...([QUEUE_TYPE.COMPLETED].includes(queueType) && prescription_id
      ? [
        {
          text: "Send Rx on WA",
          icon: <PrescriptionSolidIcon className="dr-w-16 dr-h-16" />,
          onClick: () => handleSendMsgPress(apt.aid),
          aclViewClassName: getAclViewClassName(SUBJECT_KEYS.SEND_RX),
        },
      ]
      : []),
    {
      text: "Send Google Review Link",
      icon: <GSolidIcon className="dr-w-16 dr-h-16" />,
      onClick: async () => {
        await handleReviewLinkSend();
      },
      aclViewClassName: getAclViewClassName(SUBJECT_KEYS.SEND_GOOGLE_REVIEW),
    },
    {
      text: "Appointment Activity",
      icon: <ListTimelineRegularIcon className="dr-w-16 dr-h-16" />,
      onClick: () => {
        setShowAppointmentDetailsDrawer(true);
        setSelectedAppointment(apt);
      },
    },
    {
      text: "Print Appointment Slip",
      icon: printOpdSlipLoading ? (
        <LoaderV3Icon
          className="dr-w-16 dr-h-16 animate-spin"
          style={{ fill: "none", stroke: "black" }}
        />
      ) : (
        <PrintRegularIcon className="dr-w-16 dr-h-16" />
      ),
      aclViewClassName: getAclViewClassName(SUBJECT_KEYS.PRINT_OPD_SLIP_BTN),
      onClick: handlePrintOpdSlip,
    },
    ...(printLabelEnabled
      ? [
          {
            text: "Print label",
            icon: <PrintRegularIcon className="dr-w-16 dr-h-16" />,
            onClick: () => printLabelForPatientWithId(apt.patient.oid),
          },
        ]
      : []),
    ...([QUEUE_TYPE.COMPLETED].includes(queueType) &&
      prescription_id &&
      evitalsConfig?.manualPushOrder
      ? [
        {
          text: "Push Order to Evitals",
          icon: <PillsRegularIcon className="dr-w-16 dr-h-16" />,
          onClick: () => {
            handlePushOrderToEvitals(apt.aid);
          },
        },
      ]
      : []),
    ...[
      { text: "" },
      ...(isOnGoing || isCancelled || isCompleted
        ? []
        : [
          {
            text: "Mark Cancelled",
            icon: <CircleXmarkRegularIcon className="dr-w-16 dr-h-16" />,
            onClick: async () => {
              track("mark_cancelled", {
                queueType,
              });
              const response = await putCancelAppointment({
                appointment: apt,
              });
              if (response.success) {
                notification.success({
                  message: "Appointment Cancelled",
                  description: `Your appointment with ${apt.patient.fln} has been cancelled.`,
                  placement: "bottomRight",
                });
              } else {
                notification.error({
                  message: "Error in cancelling appointment",
                  description: response.error,
                  placement: "bottomRight",
                });
              }
            },
            aclViewClassName: getAclViewClassName(SUBJECT_KEYS.CANCEL_APPT),
          },
        ]),
      ...(markNoShowConditions
        ? [
          {
            text: "Mark No Show",
            icon: <BanRegularIcon className="dr-min-w-14 dr-h-14" />,
            onClick: async () => {
              track("mark_no_show", {
                queueType,
              });
              const response = await postMarkNoShowAppointment({
                appointment: apt,
              });
              if (response.success) {
                notification.success({
                  message: "Marked No Show",
                  description: `Your appointment with ${apt.patient.fln} has been marked as no show.`,
                  placement: "bottomRight",
                });
              } else {
                notification.error({
                  message: "Error in marking no show",
                  description: response.error,
                  placement: "bottomRight",
                });
              }
            },
            aclViewClassName: getAclViewClassName(SUBJECT_KEYS.MARK_NO_SHOW),
          },
        ]
        : []),
      ...(parkVisitEnabled && parkVisitConditions
        ? [
          {
            text: "Park",
            icon: <PauseRegularIcon className="dr-min-w-14 dr-h-14" />,
            onClick: async () => {
              track("park_apt", {
                queueType,
              });
              const response = await postMarkParkedAppointment({
                appointment: apt,
              });
              if (response.success) {
                notification.success({
                  message: "Appointment Parked",
                  description: `Your appointment with ${apt.patient.fln} has been parked`,
                  placement: "bottomRight",
                });
              } else {
                notification.error({
                  message: "Error in parking the appointment",
                  description: response.error,
                  placement: "bottomRight",
                });
              }
            },
            aclViewClassName: getAclViewClassName(SUBJECT_KEYS.PARK_APT),
          },
        ]
        : []),
      {
        text: "Delete",
        icon: <TrashRegularIcon className="dr-w-16 dr-h-16" />,
        onClick: async () => {
          track("delete_init", {
            queueType,
          });
          Modal.confirm({
            title: "Are You Sure You Want to Delete the Appointment?",
            content:
              "Deleting the appointment will permanently hide associated receipts, lab test, and medicine orders.",
            onOk: async () => {
              track("delete", {
                queueType,
              });
              const response = await postArchiveAppointment({
                appointment: apt,
              });
              if (response.success) {
                notification.success({
                  message: "Appointment Deleted",
                  placement: "bottomRight",
                  description: `Your appointment with ${apt.patient.fln} has been deleted.`,
                });
              } else {
                notification.error({
                  message: "Error in deleting appointment",
                  placement: "bottomRight",
                });
              }
            },
          });
        },
        aclViewClassName: getAclViewClassName(SUBJECT_KEYS.DELETE_APPOINTMENT),
      },
    ],
  ].filter(Boolean);
};

export const MainMenu = ({
  apt,
  queueType,
}: {
  apt: Appointment;
  queueType: QUEUE_TYPE;
}) => {
  const menuItems = useGetMenuItems(apt, queueType);
  return (
    <Menu className="dr-rounded-8 dr-overflow-hidden dr-w-200 hide-submenu-arrow">
      {menuItems.map((item, index) => {
        if (item.text.length === 0) {
          return (
            <div
              key={`divider-${index}`}
              className="dr-w-full dr-h-1 dr-bg-doctor-darwin-neutral-100"
            />
          );
        }
        return <MenuItem key={`item-${index}`} {...item} />;
      })}
    </Menu>
  );
};
